export default "__VITE_ASSET__Ij8BBADS__"